import { createApi } from "@reduxjs/toolkit/query/react";
import { reducerPaths } from "../../app/reducerPaths";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";

export const upcomingCarsApi = createApi({
  reducerPath: reducerPaths.upcomingCarsApi, // Unique key in Redux store
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    setAutoBid: builder.mutation({
      query: ({ payload }) => {
        return {
          method: "POST",
          url: `/dealer/setautobid`,
          body: payload,
        };
      },
    }),
    setAutoBidBuyNow: builder.mutation({
      query: ({ payload }) => {
        return {
          method: "POST",
          url: `/dealer/SetAutoBidBuyNow`,
          body: payload
        }
      }
    }),
    getAutoBidHistory: builder.query({
      query: ({ Vehicle_Id }) => {
        return {
          url: `/dealer/AutoBidHistory/${Vehicle_Id}`,
          method: "GET"
        }
      }
    }),
    fetchFilterOptions: builder.query({
      query: ({ endpoint }) => ({
        url: endpoint,
      }),
    }),
    fetchModelOptions: builder.query({
      query: ({ endpoint, payload }) => ({
        method: "POST",
        url: endpoint,
        body: payload,
      }),
    }),
    fetchCars: builder.query({
      query: ({ params }) => ({
        method: "GET",
        url: `/myGarage/Seller/FutureAuctions`,
        params: params || {}
      }),
    }),
    fetchOwnCars: builder.query({
      query: ({ page, per_page, params }) => ({
        method: "GET",
        // url: `/myGarage/Seller/UpcomingCars?page=${page}&per_page=${per_page}`
        url: `/myGarage/Seller/FutureAuctions?page=${page}&per_page=${per_page}`,
        params: params || {}
      }),
    }),
    fetchOtherCars: builder.query({
      query: ({ page, per_page, params }) => ({
        method: "GET",
        // url: `/myGarage/Seller/UpcomingCars?page=${page}&per_page=${per_page}`
        url: `/myGarage/Dealer/UpcomingCars?page=${page}&per_page=${per_page}`,
        params: params || {}
      }),
    }),
  }),
});

export const {
  useSetAutoBidMutation,
  useSetAutoBidBuyNowMutation,
  useFetchFilterOptionsQuery,
  useFetchModelOptionsQuery,
  useFetchCarsQuery,
  useLazyFetchCarsQuery,
  useLazyFetchOwnCarsQuery,
  useLazyFetchOtherCarsQuery,
  useLazyGetAutoBidHistoryQuery
} = upcomingCarsApi;
